import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from "@angular/material/menu";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
// import { initializeApp } from "firebase/app";
// initializeApp(environment.firebase);

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoaderComponent } from './Base/loader/loader.component';
import { TranslateService } from './Service/Common/translate.service';
import { LoaderService } from './Service/Common/loader.service';
import { Constant } from './Common/constant';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { LoaderInterceptor } from './Model/Common/loader-interceptor';
import { APIFactoryEndPoints } from './Model/Common/apifactory-end-points';
import { LoginComponent } from './Base/login/login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';
import { HomeComponent } from './Base/home/home.component';
import { environment } from 'src/environments/environment';
import { MatDialogModule } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from './Base/confirmation-dialog/confirmation-dialog.component';
import { RiderDetailsComponent } from './Module/RiderDetails/rider-details/rider-details.component';
import { PrivacyPolicyComponent } from './Module/RiderDetails/privacy-policy/privacy-policy.component';
import { MatCardModule } from "@angular/material/card";
import { MAT_DATE_LOCALE, MatRippleModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule} from '@angular/material/form-field';
import { MatSelectModule } from "@angular/material/select";
import { MatSliderModule } from "@angular/material/slider";
import { MatInputModule } from "@angular/material/input";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatNativeDateModule } from "@angular/material/core";
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { GoogleChartsModule } from 'angular-google-charts';
import { HighchartsChartModule } from 'highcharts-angular';
import { NewOrderDialogComponent } from './Module/Shipping/new-order-dialog/new-order-dialog.component';
import { ShippingManagerComponent } from './Module/Shipping/shipping-manager/shipping-manager.component';
import { ShippingStatusComponent } from './Module/Shipping/shipping-status/shipping-status.component';
import { ShippingDetailsComponent } from './Module/Shipping/shipping-details/shipping-details.component';
import { MultipleTransactionComponent } from './Module/Shipping/multiple-transaction/multiple-transaction.component';
import { CreateOrderCustomerComponent } from './Module/Shipping/create-order-customer/create-order-customer.component';
import { MobileNumberVerificationDialogComponent } from './Module/Shipping/mobile-number-verification-dialog/mobile-number-verification-dialog.component';
import { ShippingStartComponent } from './Module/Shipping/shipping-start/shipping-start.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ShippingRatingComponent } from './Module/Shipping/shipping-rating/shipping-rating.component';
import { MatTabsModule } from '@angular/material/tabs';
import { AgmCoreModule } from '@agm/core';
import { AgmDirectionModule } from 'agm-direction';
import { MatGridListModule } from '@angular/material/grid-list';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { QRCodeModule } from 'angularx-qrcode';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { AbsolutePipe } from './Common/Pipe/absolute.pipe';
import { NgxKeyboardShortcutModule } from 'ngx-keyboard-shortcuts';
import { FlexLayoutModule } from "@angular/flex-layout";
import moment from 'moment';
import { RiderOrdersComponent } from './Module/Reports/rider-orders/rider-orders.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { RiderAccountsComponent } from './Module/Reports/rider-accounts/rider-accounts.component';
import { TripsComponent } from './Module/Reports/trips/trips.component';
import {RatingsComponent} from './Module/Reports/ratings/ratings.component'
import { DashboardComponent } from './Module/RiderDetails/dashboard/dashboard.component';
import { PreAppAndroidComponent } from './Module/pre-app-android/pre-app-android.component';
import { ImagePreviewDialogComponent } from './Module/RiderDetails/image-preview-dialog/image-preview-dialog.component';
import { DatePipe } from '@angular/common';
import { HelpDialogComponent } from './Base/help-dialog/help-dialog.component';
import { OtpDialogComponent } from './Base/otp-dialog/otp-dialog.component';
import { ChatComponent } from './Common/chat/chat.component';
import { ChatService } from './Common/chat/ChatService';
import { NewOrderMapDialogComponent } from './Module/Shipping/new-order-map-dialog/new-order-map-dialog.component';
import { WebSocketService } from './Common/WebSocketService';
import { HttpinterceptorInterceptor } from './HttpinterceptorInterceptor';
import { AppConfigService } from './Service/Configuration/app-config.service';
import { GoogleMapsModule } from '@angular/google-maps';

export function initializeAppConfiguration(appConfig: AppConfigService) {
  return () => appConfig.loadConfig();
}

@NgModule({
  declarations: [
    AppComponent,
    LoaderComponent,
    LoginComponent,
    HomeComponent,
    ConfirmationDialogComponent,
    RiderDetailsComponent,
    DashboardComponent,
    PrivacyPolicyComponent,
    NewOrderDialogComponent,
    ShippingManagerComponent,
    ShippingStatusComponent,
    ShippingDetailsComponent,
    MultipleTransactionComponent,
    CreateOrderCustomerComponent,
    MobileNumberVerificationDialogComponent,
    ShippingStartComponent,
    ShippingRatingComponent,
    AbsolutePipe,
    RiderOrdersComponent,
    RiderAccountsComponent,
    TripsComponent,
    RatingsComponent,
    PreAppAndroidComponent,
    ImagePreviewDialogComponent,
    HelpDialogComponent,
    OtpDialogComponent,
    ChatComponent,
    NewOrderMapDialogComponent,

  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MatToolbarModule,
    MatIconModule,
    MatDialogModule,
    MatMenuModule,
    ReactiveFormsModule,
    MatCardModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatSliderModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSlideToggleModule,
    MatGridListModule,
    MatAutocompleteModule,
    MatRippleModule,
    MatTableModule,
    MatTooltipModule,
    FlexLayoutModule,
    FormsModule,
    NgbModule,
    BrowserAnimationsModule,
    HttpClientModule,
    ToastrModule.forRoot(),
    GoogleChartsModule,
    HighchartsChartModule,
    MatTabsModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyAEU3XtsD3WDUIhG9c9NyTsR7RsIX5HU2E',
      libraries: ['places']
    }),
    AgmDirectionModule,
    NgxMaterialTimepickerModule,
    QRCodeModule,
    NgxKeyboardShortcutModule,
    MatCheckboxModule,
    GoogleMapsModule,    
  ],
  providers: [
    TranslateService,
    LoaderService,
    Constant,
    DatePipe,
    ChatService,
    WebSocketService,
    { provide: HTTP_INTERCEPTORS, useClass: HttpinterceptorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { floatLabel: 'auto' } },
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    { provide: APP_INITIALIZER, useFactory: initializeAppConfiguration, deps: [AppConfigService], multi: true },

    APIFactoryEndPoints,
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor() {
    Date.prototype.toJSON = function () {
      return moment(this).format("YYYY-MM-DDTHH:mm:ss");
    }
  }
 }
